import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function BenefitsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-28 px-6 bg-dark-bg" data-id="element-16">
      <div className="max-w-4xl mx-auto text-center" data-id="element-17">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl font-serif font-bold text-text-primary mb-6" data-id="element-18">
          Esto no es un curso complicado.
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-xl md:text-2xl text-accent font-semibold" data-id="element-19">
          Es el punto donde dejas de no saber qué hacer… y empiezas a crear
          contenido real.
        </motion.p>
      </div>
    </section>;
}